// -----------------------------
// tiny loaders (reusable)
// -----------------------------
function hhLoadScript(src, cb) {
  if (document.querySelector('script[data-hh-src="' + src + '"]')) {
    cb && cb();
    return;
  }
  var s = document.createElement('script');
  s.src = src;
  s.async = true;
  s.dataset.hhSrc = src;
  s.onload = function () { cb && cb(); };
  document.head.appendChild(s);
}

function hhLoadCss(href, cb) {
  if (document.querySelector('link[data-hh-css="' + href + '"]')) {
    cb && cb();
    return;
  }
  var l = document.createElement('link');
  l.rel = 'preload';
  l.as = 'style';
  l.href = href;
  l.dataset.hhCss = href;
  l.onload = function () {
    this.rel = 'stylesheet';
    cb && cb();
  };
  document.head.appendChild(l);
}

// -----------------------------
// Sticky basket bar
// -----------------------------
document.addEventListener("DOMContentLoaded", () => {
  const stickyBar = document.getElementById("sticky-basket-bar");
  const productTitleElement = document.querySelector(".prodinfo__title");
  const productPriceElement = document.querySelector(".prodinfo__price");
  const quantitySelectElement = document.getElementById("quantselect");
  const addToCartButton = document.querySelector("form[action='/cart/add'] .btn[type='submit']");

  if (
    stickyBar &&
    productTitleElement &&
    productPriceElement &&
    quantitySelectElement &&
    addToCartButton
  ) {
    const productTitle = productTitleElement.innerText;
    const productPrice = productPriceElement.innerText;
    const productQuantity = quantitySelectElement.value;

    const stickyProductTitle = document.getElementById("sticky-product-title");
    const stickyProductPrice = document.getElementById("sticky-product-price");
    const stickyQuantitySelect = document.getElementById("sticky-product-quantity");

    stickyProductTitle.innerText = productTitle;
    stickyProductPrice.innerText = productPrice;

    stickyQuantitySelect.innerHTML = quantitySelectElement.innerHTML;
    stickyQuantitySelect.value = productQuantity;

    quantitySelectElement.addEventListener("change", () => {
      stickyQuantitySelect.value = quantitySelectElement.value;
    });

    stickyQuantitySelect.addEventListener("change", () => {
      quantitySelectElement.value = stickyQuantitySelect.value;
    });

    const productInfoOffset = productTitleElement.offsetTop;
    let scrollTimeout;

    window.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (window.scrollY > productInfoOffset) {
          stickyBar.classList.add("visible");
        } else {
          stickyBar.classList.remove("visible");
        }
      }, 100);
    });

    const stickyAddToCart = document.getElementById("sticky-add-to-cart");
    if (stickyAddToCart) {
      stickyAddToCart.addEventListener("click", () => {
        addToCartButton.click();
      });
    }
  }
});

// -----------------------------
// Swiper-based product gallery
// (use what Liquid rendered, don't move nodes)
// -----------------------------
function loadSwiperLib() {
  if (typeof window.hhLoadSwiper === "function") {
    return window.hhLoadSwiper();
  }
  if (window.Swiper) {
    return Promise.resolve(window.Swiper);
  }
  return Promise.reject("Swiper not available");
}

let swiperInstance = null;
let swiperInitRequested = false;

function initializeSwiper() {
  const container =
    document.querySelector(".prodgallery__carousel .swiper-container") ||
    document.querySelector(".prodgallery__carousel");
  if (!container) return;
  if (swiperInstance) return;

  swiperInstance = new Swiper(container, {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
    },
  });
}

function requestSwiperInit() {
  if (swiperInitRequested) return;
  swiperInitRequested = true;

  loadSwiperLib()
    .then(() => {
      initializeSwiper();
    })
    .catch(() => {
      // swallow
    });
}

function initSwiperWhenVisible() {
  const target =
    document.querySelector(".prodgallery__carousel") ||
    document.querySelector(".swiper-container");
  if (!target) return;

  if (!("IntersectionObserver" in window)) {
    requestSwiperInit();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestSwiperInit();
        io.disconnect();
      }
    });
  });

  io.observe(target);
}

window.addEventListener("load", function () {
  // no adjustProductImages() anymore – Liquid already output both
  initSwiperWhenVisible();
});

// -----------------------------
// scroll-to-reviews
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.getElementById("klaviyo-star-rating-widget-top");
  const target = document.getElementById("bundle-reviews");

  if (trigger && target) {
    trigger.style.cursor = "pointer";
    trigger.addEventListener("click", function () {
      const rect = target.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetTop = rect.top + scrollTop;
      const offset = targetTop - window.innerHeight / 2;

      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    });
  }
});

// -----------------------------
// LAZY PHOTOSWIPE (robust version)
// -----------------------------
(function () {
  var assetNode = document.getElementById('pswp-asset-urls');
  if (!assetNode) return;

  var PSWP_URLS = {
    css: assetNode.dataset.css,
    lightbox: assetNode.dataset.lightbox,
    pswp: assetNode.dataset.pswp
  };

  function loadCssOnce(href) {
    return new Promise(function (resolve) {
      if (document.querySelector('link[data-pswp-css="' + href + '"]')) {
        resolve();
        return;
      }
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.dataset.pswpCss = href;
      l.onload = function () { resolve(); };
      document.head.appendChild(l);
    });
  }

  var lightboxPromise = null;
  function getLightboxInstance() {
    if (lightboxPromise) return lightboxPromise;

    lightboxPromise = Promise.all([
      loadCssOnce(PSWP_URLS.css),
      import(PSWP_URLS.lightbox)
    ]).then(function (mods) {
      var PhotoSwipeLightbox = mods[1].default;

      var lightbox = new PhotoSwipeLightbox({
        gallery: '.zoomwrap, .prodgallery__grid, .prodgallery__carousel, #image-grid, #image-carousel',
        children: 'a',
        pswpModule: function () {
          return import(PSWP_URLS.pswp);
        }
      });

      lightbox.init();
      return lightbox;
    });

    return lightboxPromise;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var clickable = document.querySelectorAll(
      '.zoomwrap a, .prodgallery__grid a, .prodgallery__carousel a, #image-grid a, #image-carousel a'
    );
    if (!clickable.length) return;

    var clickableArr = Array.from(clickable);

    clickableArr.forEach(function (link) {
      link.addEventListener('click', function (ev) {
        ev.preventDefault();

        var index = clickableArr.indexOf(link);

        getLightboxInstance()
          .then(function (lightbox) {
            setTimeout(function () {
              lightbox.loadAndOpen(index);
            }, 0);
          })
          .catch(function (err) {
            console.warn('PhotoSwipe failed to load', err);
            window.location.href = link.href;
          });
      });
    });
  });
})();

// -----------------------------
// LAZY KLAVIYO REVIEWS LOAD
// -----------------------------
(function () {
  var rev = document.querySelector(".klaviyo-star-rating-widget");
  var api = "{{ settings.klaviyo_api }}"; // use theme setting
  if (!rev || !api) return;

  if (!("IntersectionObserver" in window)) {
    hhLoadScript("https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + api);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        hhLoadScript("https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + api);
        io.disconnect();
      }
    });
  });

  io.observe(rev);
})();